<template>
  <div class="container">
    <div class="detail-content">
      <div class="detail-box">
        <div
          class="detail-wrap"
          v-for="(item, index) in BillArray"
          :key="index"
        >
          <div class="time-data">
            {{ item.month | routeMonth }}
            <span class="time-desc">月</span>
          </div>
          <div class="content">
            <span class="mtitle">广告收入</span>
            <span class="value">{{ item.ad }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">贡献点收入</span>
            <span class="value">{{ item.contribution }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">迷你点折算收入</span>
            <span class="value">{{ item.minipoint }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">其他收入</span>
            <span class="value">{{ item.other }}元</span>
          </div>
          <div class="conclusion-box">
            <span class="conclusion">合计：</span>
            <span class="conclusion-value">
              <span class="conclusion-title">{{
                (item.ad + item.other + item.contribution + item.minipoint)
                  | routeMoney
              }}</span>
              元
            </span>
          </div>
        </div>
        <div class="history-money" v-if="historyMoney">
          <span class="value">2022-01-01日前待结算收益</span>
          <span class="desc">{{ historyMoney }}元</span>
        </div>
      </div>
      <div class="submit-btn">
        <div class="comfirm-btn" v-if="id == 0" @click="confirmMoney">
          确认金额
        </div>
        <div class="download-btn" @click="downloadBill">下载结算单</div>
      </div>
      <div class="desc-bottom">
        <span class="desc"> 详细请查看</span>
        <a href="https://dev-wiki.mini1.cn/news/2069" target="_blank">
          《迷你平台结算规则说明》
        </a>
      </div>
    </div>
    <!--确认金额弹框-->
    <div class="income-dialog">
      <van-dialog
        v-model="showCode"
        title="结算单确认"
        :show-confirm-button="false"
        :closeOnClickOverlay="true"
      >
        <div class="box">
          <div class="withdraw-all-money">
            <p>待结算金额</p>
            <p class="all-money-num">
              {{ money | routeMoney }}
            </p>
          </div>
          <div class="user-title">
            <span class="user-label">开户名</span>
            {{ bankInfo.name }}
          </div>
          <div class="bank-title">
            提现账号
            <span class="bank-label">
              <img src="@/assets/images/icon_bank.png" />
              {{ bankInfo.bank_name }}（
              {{ bankInfo.bank_card | regroupBankCard }}）
            </span>
          </div>
          <div class="code-desc">
            请输入手机号+86 {{ developerInfo.phone | protectPhoneNumber }}上的验证码
          </div>
          <van-password-input
            :value="form.vercode"
            :focused="showKeyboard"
            :mask="false"
            @focus="showKey"
          >
          </van-password-input>
          <!--数字键盘-->
          <van-number-keyboard
            v-model="form.vercode"
            :show="showKeyboard"
            @blur="blurKey"
            @input="checkIsCompleted"
          >
          </van-number-keyboard>
          <div class="bottom-desc">
            <span class="desc" v-if="isDisabled">没有收到？</span>
            <span
              class="btn-code"
              :class="{ 'btn-forbid': isDisabled }"
              @click="getCode"
              >{{ codeTxt }}</span
            >
          </div>
        </div>
        <div class="submit-btn">
          <div class="content" @click="submitApply">确认</div>
        </div>
        <p class="desc-tip">由于扣税及手续费等因素，请以实际到账金额为准</p>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import { fetchOverview, fetchBillIncome, withdraw } from '@/api/income';
// import { checkoutPhone, checkoutCode } from '../../checkoutReg';
import { protectPhoneNumber as savePhoneNumber } from '@/utils/index';
import { getVercode } from '@/api/common';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      BillArray: [],
      historyMoney: 0,
      create_time: 0,
      money: 0,
      showCode: false,
      form: { vercode: '' },
      showKeyboard: false,
      isDisabled: false,
      id: '',
      showDialog: false,
      codeTxt: '获取验证码',
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.money = this.$route.query.money || 0;
    this.create_time = this.$route.query.create_time || 0;
    this.getDetailData();
    this.developerInfo.phone = 15521677829;
  },
  computed: {
    ...mapState(['developerInfo', 'bankInfo', 'userInfo']),
  },
  filters: {
    protectPhoneNumber(phoneNumber) {
      return savePhoneNumber(phoneNumber);
    },
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    routeMonth(time) {
      time.toString();
      let year = time.toString().slice(0, 4);
      let month = time.toString().slice(4);
      let result = year + '-' + month;
      return result;
    },
    routeMoney(value) {
      let money = parseFloat(value);
      return money.toFixed(2);
    },
    regroupBankCard(val) {
      if (val) {
        return val.substring(val.length - 4);
      }
    },
    regroupComma(val) {
      if (val != undefined) {
        if (val.toString().includes('.')) {
          let reg = /(\d)(?=(\d{3})+\.)/g;
          // let point = '';
          // type == 1 ? (point = 2) : (point = 2);
          return val.toFixed(2).toString().replace(reg, '$1,');
        } else {
          let reg = /(\d)(?=(?:\d{3})+$)/g;
          return val.toString().replace(reg, '$1,');
        }
      }
    },
  },
  methods: {
    checkIsCompleted() {
      console.log('checkIsCompleted', this.form.vercode);
      // TODO 实际触发总比现有值慢一步
      if (this.form.vercode.length >= 5) {
        // 输入完成
        this.showKeyboard = false;
        this.submitApply();
      }
    },
    showKey() {
      this.showKeyboard = true;
    },
    blurKey() {
      this.showKeyboard = false;
    },
    // 获取公共验证码接口
    async fetchGetVercode(phone) {
      try {
        await getVercode({ phone, tk: this.userInfo.tk });
        this.$toast.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 提现接口
    async fetchWithdraw(data) {
      try {
        const res = await withdraw(data);
        this.$toast.success('已成功发起申请');
        this.showCode = false;
        // this.$router.push({
        //   path: '/income/withdrawDetail',
        //   query: { id: res.data.id, money_type: this.withdrawInfo.type },
        // });
      } catch (error) {
        console.log(error);
      }
    },
    // 确认金额
    submitApply() {
      if (!this.form.vercode) {
        return this.$message.error('请输入验证码');
      }
      let data = {
        money_type: 1,
        money: this.money,
        vercode: this.form.vercode,
      };
      this.fetchWithdraw(data);
    },
    // 倒计时
    countDown() {
      let time = 60;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '重新发送';
        }
      }, 1000);
    },
    getCode() {
      if (!this.developerInfo.phone) this.$toast.fail('手机号不能为空');
      else this.fetchGetVercode(this.developerInfo.phone);
    },
    //获取订单明细数据
    async getDetailData() {
      //清空BillArray
      try {
        this.BillArray = [];
        this.historyMoney = 0;
        const res = await fetchBillIncome({ id: this.id });
        //判断是否存在历史遗留金额
        if (res.data.list.length) {
          res.data.list.map(item => {
            if (item.month === 202200) {
              this.historyMoney = item.wallet;
            } else {
              this.BillArray.push(item);
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 下载结算单
    async downloadBill() {
      try {
        const res = await fetchOverview();
        this.downloadFile(res.data.url);
        this.$message.success('结算单下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    confirmMoney() {
      console.log(111);
      this.showCode = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-content {
  padding-top: 8px;
  .detail-box {
    background: #ffffff;
    min-height: 400px;
  }
  .detail-wrap {
    border-radius: 8px;
    width: 710px;
    padding: 32px 26px 31px 32px;
    .time-data {
      color: #000000;
      font-size: 34px;
      margin-bottom: 22px;
    }
    .content {
      color: #595959;
      font-size: 28px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
    }
    .conclusion-box {
      margin-top: 25px;
      color: #000000;
      font-size: 28px;
      display: flex;
      justify-content: space-between;
    }
  }
  .history-money {
    padding: 23px 26px 31px 32px;
    display: flex;
    justify-content: space-between;
    color: #000000;
    font-size: 28px;
  }
  .submit-btn {
    margin-top: 32px;
    padding-left: 175px;
    font-size: 32px;
    .comfirm-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 32px;
      height: 90px;
      background: #fd9b21;
      border-radius: 8px;
      width: 360px;
      color: #ffffff;
    }
    .download-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 57px;
      background: #fffaed;
      border-radius: 8px;
      color: #fd9b21;
      border: 2px solid #ffc973;
      width: 360px;
      height: 90px;
    }
  }
  .desc-bottom {
    text-align: center;
    color: #8c8c8c;
    font-size: 24px;
    a {
      color: #2b6ddfff;
    }
  }
}
.van-dialog {
  background: #ffffff;
  width: 710px;
  height: 1000px;
  /deep/.van-dialog__header {
    padding-top: 20px;
    font-size: 36px;
    font-weight: 500;
    color: #000000;
    // margin-bottom: 30px;
  }
  .box {
    width: 710px;
    height: 487px;
    background: #ffffff;
    border-radius: 8px;
    .withdraw-all-money {
      text-align: center;
      color: #262626;
      margin-top: 20px;
      font-size: 24px;
      .all-money-num {
        font-size: 34px;
        color: #fd9b21;
      }
    }
    .user-title {
      padding-left: 40px;
      font-size: 30px;
      margin-top: 20px;
      .user-label {
        margin-right: 60px;
      }
    }
    .bank-title {
      padding-left: 40px;
      font-size: 30px;
      display: flex;
      align-items: center;
      margin-top: 30px;
      .bank-label {
        margin-left: 40px;
        display: flex;
        align-items: center;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .code-desc {
      margin-top: 30px;
      width: 100%;
      text-align: center;
      color: #8c8c8c;
      font-size: 28px;
      margin-bottom: 45px;
    }
    .bottom-desc {
      width: 100%;
      margin-top: 90px;
      text-align: center;
      color: #8c8c8c;
      font-size: 24px;
      .btn-code {
        color: #2b6ddfff;
        .btn-forbid {
          color: #8c8c8c;
        }
      }
    }
  }
  .submit-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 130px;
    .content {
      width: 360px;
      height: 90px;
      background: #fd9b21;
      border-radius: 8px;
      color: #ffffff;
      text-align: center;
      font-size: 32px;
      padding-top: 23px;
    }
  }
  .desc-tip {
    margin-top: 15px;
    width: 100%;
    text-align: center;
    font-size: 28px;
  }
  /deep/.van-number-keyboard {
    margin-top: 300px;
    padding-bottom: 0;
  }
}
</style>
